import React, { useState } from "react";

const LanguageSelector = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentLang, setCurrentLang] = useState({
    flag: "🇬🇧",
    name: "English",
    code: "en",
  });

  const languages = [
    { flag: "🇬🇧", name: "English", code: "en" },
    { flag: "🇪🇸", name: "Español", code: "es" },
    { flag: "🇫🇷", name: "Français", code: "fr" },
    { flag: "🇩🇪", name: "Deutsch", code: "de" },
    { flag: "🇨🇳", name: "中文", code: "zh" },
  ];

  return (
    <div
      style={{
        position: "absolute",
        top: "45%",
        right: 0,
        transform: "translateY(-50%)",
        zIndex: 1000,
      }}
    >
      <div style={{ position: "relative" }}>
        <button
          style={{
            background: "rgba(255,255,255,0.15)",
            // border: "1px solid rgba(0,0,0,0.15)",
            borderRadius: 4,
            padding: "4px 10px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: 20,
            fontSize: 20,
            color: "#434343",
          }}
          onClick={() => setIsOpen(!isOpen)}
        >
          <span style={{ fontSize: 21 }}>{currentLang.flag}</span>
          {/* <span style={{ fontSize: 15 }}>{currentLang.name}</span> */}
          <span style={{ fontSize: 9 , marginRight: 10, marginTop: 5}}>▼</span>
        </button>

        {isOpen && (
          <div
            style={{
              position: "absolute",
              top: "100%",
              right: 0,
              marginTop: 4,
              background: "#1e2832",
              borderRadius: 8,
              boxShadow: "0 4px 15px rgba(0,0,0,0.3)",
              width: 140,
              zIndex: 1001,
            }}
          >
            {languages.map((lang, index) => (
              <div
                key={index}
                style={{
                  padding: "8px 12px",
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  cursor: "pointer",
                  transition: "background 0.2s",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.background = "rgba(255,255,255,0.1)")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.background = "transparent")
                }
                onClick={() => {
                  setCurrentLang(lang);
                  setIsOpen(false);
                }}
              >
                <span style={{ fontSize: 16 }}>{lang.flag}</span>
                <span style={{ fontSize: 13, color: "#fff" }}>{lang.name}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default LanguageSelector;
